/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MedCrossIcon24Solid = forwardRef('MedCrossIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M9.75 2A1.75 1.75 0 0 0 8 3.75V8H3.75A1.75 1.75 0 0 0 2 9.75v4.5c0 .966.784 1.75 1.75 1.75H8v4.25c0 .966.784 1.75 1.75 1.75h4.5A1.75 1.75 0 0 0 16 20.25V16h4.25A1.75 1.75 0 0 0 22 14.25v-4.5A1.75 1.75 0 0 0 20.25 8H16V3.75A1.75 1.75 0 0 0 14.25 2h-4.5Z" })));
});
